export default __webpack_public_path__ + "static/media/winter-baby.bebc79f4.jpg";